import { http } from 'common/services';
import { ENDPOINTS } from 'defaults';
import { SpecializationSearchType } from 'models';

export const searchSpecialization = async (value: string) => {
  let { SPECIALIZATION_SEARCH: endpoint } = ENDPOINTS.REFERENCE;
  return http.get<SpecializationSearchType[]>(endpoint.name, `${endpoint.url}?term=${value}`, '', true);
};
